import { createSelector } from 'reselect'

const getLessonsPicker = state => state.lessonsPicker
const getLessons = state => state.lessons

const storefrontLessonsPickerModalSaveSelector = createSelector(
	[ getLessonsPicker, getLessons ],
	(lessons_picker, lessons) => {

		const lessonsIDs = []
		const lessonsUIDs = []
		lessons_picker.selected_lessons
			.map(id => {
				lessonsIDs.push(lessons[id].data.id)
				lessonsUIDs.push(lessons[id].data.entityUID)
			})

		return {
			lessonsIDs,
			lessonsUIDs,
		}
	}
)

export default storefrontLessonsPickerModalSaveSelector
